import StoreDefineUser from '@/define/store/user/user'
import DashboardModuleInfo from '@/model/user/DashboardModuleInfo'
import DashboardServiceInfo from '@/model/user/DashboardServiceInfo'

export interface State {
  dashboardModules: DashboardServiceInfo[];
  selectedDashboardModule: DashboardModuleInfo
}

const state: State = {
  dashboardModules: [],
  selectedDashboardModule: new DashboardModuleInfo('', '', '')
}

const getters = {
  [StoreDefineUser.GET_DASHBOARD_MODULES](state: State) {
    return state.dashboardModules
  },
  [StoreDefineUser.GET_SELECTED_DASHBOARD_MODEL](state: State) {
    return state.selectedDashboardModule
  }
}

const mutations = {
  [StoreDefineUser.SET_DASHBOARD_MODULES](state: State, dashboardModules: DashboardServiceInfo[]) {
    state.dashboardModules = dashboardModules
  },
  [StoreDefineUser.SET_SELECTED_DASHBOARD_MODEL](state: State, selectedDashboardModule: DashboardModuleInfo) {
    state.selectedDashboardModule = selectedDashboardModule
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
